// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"517":"f7e24543","726":"17919a19"}[chunkId] + ".chunk.js";
};